export default __webpack_public_path__ + "components/03-features/brand/footer-contacts/footer__contact.html.twig";